import { render, staticRenderFns } from "./AccountSettingsForm.vue?vue&type=template&id=be6e2d0c&"
import script from "./AccountSettingsForm.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports